import { render } from "./multilanguage.vue?vue&type=template&id=e6695a68&scoped=true"
import script from "./multilanguage.vue?vue&type=script&lang=js"
export * from "./multilanguage.vue?vue&type=script&lang=js"

import "./multilanguage.vue?vue&type=style&index=0&id=e6695a68&lang=scss"
import "./multilanguage.vue?vue&type=style&index=1&id=e6695a68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6695a68"]])

export default __exports__